
































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseThrealtimedata from "./analyse-threaltimedata.vue";
import AnalyseNThrealtimedata from '../enthrealtimedata/analyse-enthrealtimedata.vue';
import * as XLSX from "xlsx";
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId: Number;
  etype:String = "3";
  EndTime: Date = new Date();
  mac: string;
  Time: string;
  displayId:number;
}
class PageCompanyRequest {
  cId: Number;
  ftId:Number;
  wId:Number;
}
@Component({
  components: { AnalyseThrealtimedata,AnalyseNThrealtimedata },
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  analyseModalShow: boolean = false;
  NanalyseModalShow:boolean = false;
  userName: string;
  cId: Number;
  list1;
  totalcount=0;
  mac:string='';
  wflocation:string='';
  selDateTime:Date=new Date();
  datalist1 = [];
  temp:string = '';
  humi = [];
  mac1:string='';
  mac2:string='';
  mac3:string='';
  scId:number;
  yieldly:string='';
  years:string='';
  grade:string='';
  IsPostBack:boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  datalist = [];
  etype=null;

  get list() {
    return this.$store.state.thequipment.list;
  }
  get loading() {
    return this.$store.state.thequipment.loading;
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.$store.state.thequipment.currentPage=1;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
      if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      // this.getfloor();
      if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
      this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  //楼层
  selfloor(value:Number){
    this.$store.state.thequipment.currentPage=1;
    this.getPage();
  }
  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getPage();

  }
  pageChange(page: number) {
    this.$store.commit("thequipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thequipment/setPageSize", pagesize);
    this.getPage();
  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.datalist = await this.$store.dispatch({
      type: "thequipment/GetRealPaged",
      data: this.pagerequest,
    });
  }

 
  get pageSize() {
    return this.$store.state.thequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.thequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.thequipment.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get thequipment() {
    return this.$store.state.thequipment.list;
  }
  thequipmentlist() {
    return this.$store.state.thequipment.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  analyse() {
    this.selDateTime=this.pagerequest.EndTime;
    this.analyseModalShow = true;
  }
  Nanalyse(){
    this.selDateTime = this.pagerequest.EndTime;
    this.NanalyseModalShow = true;
  }
  setmac(mac,scId,mac1,mac2,mac3,etype){
    this.mac=mac;
    this.scId=scId;
    if(mac1 !== null){
      this.mac1 = mac1;
    }
    if(mac2 !== null){
      this.mac2 = mac2;
    }
    if(mac3 !== null){
      this.mac3 = mac3;
    }
    this.etype = etype;
    
  }
    setsmoke(sid){
    let smokelist = this.smokecriblist();
    for(let entry of smokelist){
      if(sid == entry.id){
        this.yieldly = entry.yieldly;
        this.years = entry.year;
        this.grade = entry.grade;
        break;
      }
    }
  }
  setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.wflocation =ftid + wid + fid + paramlocation;
    if(ftid == 0){
      this.wflocation =wid + fid + paramlocation;
    }
    if(paramlocation == null){
      this.wflocation = ftid + wid + fid + paramlocation;
    }

  }
  

  columns = [
    {
      title: "所属公司",
      key: "cId",
      width:150,
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
     {
      title: "库区",
      key: "ftId",
      width:160,
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wName",
      width:180,
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fName",
      width:110,
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
      width:130,
    },
     {
      title: "烟叶",
      key: "scId",
      width:200,
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "垛位号",
      key: "locationName",
      width:100,
    },
    {
      title: "剩余电量",
      key: "electric",
      width:100,
      render: (h, params) => {
        let Electric = params.row.electric;
         let username = this.getuserName();
        if(username !== "admin"){
         if(Electric > 30){
            Electric = "电量充足";
          }
          else if(Electric > 11 && Electric < 31){
             Electric = "电量一般";
          }
          else{
             Electric = "电量不足";
          }
        }
        else{
          Electric= Electric.toString() + "%";
        }
        return h("span",Electric);
      },
    },
    {
      title: "信号强度",
      key: "signale",
      width:100,
      render: (h, params) => {
        return h("span", params.row.signale+'%');
      },
    },
    {
      title: "温度",
      key: "temp",
      width:150,
       render: (h, params) => {
         if(params.row.etype == 1){
           var temp = "一号针：" + params.row.temp1 + "℃\n" + "二号针："+ params.row.temp2 + "℃\n" + "三号针：" + params.row.temp3 + "℃";
         }
         else{
           var temp = params.row.temp1 + "℃";

         }
         
        return h("span",{style:"white-space: pre-wrap"}, temp);
      },
    },
    {
      title: "湿度",
      key: "humi",
      width:150,
       render: (h, params) => {
         if(params.row.etype == 1){
            var humi = "一号针：" + params.row.humi1 + "%\n" + "二号针："+ params.row.humi2 + "%\n" + "三号针：" + params.row.humi3 + "%";
         }
         else{
           var humi = params.row.humi1 + "%";
         }
         
        return h("span",{style:"white-space:pre-wrap"}, humi);
      },
    },
    {
      title: "更新时间",
      key: "endTime",
      width:160,
      render: (h, params) => {
        let endTime ='';
        
        endTime=this.GetDay(params.row.endTime)+ " " +this.GetMinutes(params.row.endTime);
        return h("span", endTime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 100,
      fixed:"right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                  this.setsmoke(params.row.scId);
                   let strtime = params.row.endTime;
                 let datetime1 = new Date(params.row.endTime);
                  if(strtime.toString() == '0001-01-01T00:00:00'){
                    datetime1 = new Date();
                 }
                 this.pagerequest.EndTime = datetime1;
                 this.setmac(params.row.mac,params.row.scId,params.row.maC1,params.row.maC2,params.row.maC3,params.row.etype);
                 this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
                   //console.log(this.mac+'aaa');
                   if(params.row.etype == 2){
                     this.Nanalyse();
                  }else{
                    this.analyse();
                  }
                  
                },
              },
            },
            "数据分析"
          ),
         
        ]);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
    }
        async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
    this.$store.state.thequipment.pageSize=10;
    this.$store.state.thequipment.currentPage=1;
    this.$store.state.thequipment.totalCount=0;
    this.getuserName();
    this.getwarehouse();
    this.getfloor();
    this.getfactory();
    this.getsmokecrib();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
  }
}
